import { ComumModule } from './../comum/comum.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { TextMaskModule } from 'angular2-text-mask';
import { routing } from './../rotas';
import { PipesModule } from './../comum/filtros/pipes/pipes.module';

import { ClienteService } from './cliente.service';

import { CadastroClienteComponent } from './cadastro-cliente/cadastro-cliente.component';
import { ListarClientesComponent } from './listar-clientes/listar-clientes.component';
import { SelecaoClientesComponent } from './selecao-clientes/selecao-clientes.component';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { CookieService } from 'angular2-cookie/services/cookies.service';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    TextMaskModule,
    ComumModule,
    PipesModule,
    routing,
    LoadingModule.forRoot({
        animationType: ANIMATION_TYPES.circle})
  ],
  declarations: [
    CadastroClienteComponent,
    ListarClientesComponent,
    SelecaoClientesComponent,
  ],
  providers: [ClienteService, CookieService],
  exports: [CadastroClienteComponent, ListarClientesComponent, SelecaoClientesComponent]
})
export class ClienteModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/cliente/cliente.module.ts